const colors = {
  purple: {
    rect: '#B77FFF',
    path: '#340368',
    stroke: '#6C5596',
  },
  purpleBorder: {
    rect: 'transparent',
    path: '#6C5596',
    stroke: '#6C5596',
  },
  yellow: {
    rect: '#fff500',
    path: '#442d04',
    stroke: '#8a7b25',
  },
}

type ExclamationMarkProps = {
  color?: keyof typeof colors
} & React.SVGProps<SVGSVGElement>

export const ExclamationMark = ({ color = 'purple', ...props }: ExclamationMarkProps) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1" y="1" width="24" height="24" rx="12" fill={colors[color].rect} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.33594 12.9987C6.33594 9.31936 9.3226 6.33203 13.0026 6.33203C16.6893 6.33203 19.6693 9.31936 19.6693 12.9987C19.6693 16.6794 16.6893 19.6654 13.0026 19.6654C9.3226 19.6654 6.33594 16.6794 6.33594 12.9987ZM12.4167 10.4721C12.4167 10.1528 12.6833 9.88542 13.0033 9.88542C13.3233 9.88542 13.5833 10.1528 13.5833 10.4721V13.4188C13.5833 13.7394 13.3233 13.9988 13.0033 13.9988C12.6833 13.9988 12.4167 13.7394 12.4167 13.4188V10.4721ZM13.0085 16.1191C12.6819 16.1191 12.4219 15.8525 12.4219 15.5325C12.4219 15.2125 12.6819 14.9525 13.0019 14.9525C13.3285 14.9525 13.5885 15.2125 13.5885 15.5325C13.5885 15.8525 13.3285 16.1191 13.0085 16.1191Z"
      fill={colors[color].path}
    />
    <rect
      x="1"
      y="1"
      width="24"
      height="24"
      rx="12"
      stroke={colors[color].stroke}
      strokeWidth="2"
    />
  </svg>
)
